<template>
    <div style="text-align: center; position: fixed; bottom: 10px;left: 50%; transform: translate(-50%, -50%);" v-if="isMobile.isMobile()">
        <Button :label="$t('utils.signout')" class="p-button-raised p-button-help p-button-text" @click="Logout" />
    </div>
</template>

<script>
import isMobile from '@/mixins/device';
import Button from 'primevue/button';

export default {
    name: 'LogoutButton',
    components: {
        Button,
    },
    data: function() {
        return {
            isMobile,
        }
    },
    methods: {
        Logout: function() {
            if(isMobile.isMobile()) {
                this.$router.push({ path: '/admin/logout' });
            }
        },
    },
}
</script>

<style scoped>
</style>
